import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import ProductItem from "./ProductItem";
import activeDiscount from "../helpers/activeDiscount";
import calculatePrice from "../helpers/calculatePrice";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../config";

import Loading from "./shared/Loading";
import { connect } from "react-redux";
import { recentlyAddedProducts } from "../store/actions/product";
import CartItem from "./CartItem";

class OrderDetailProducts extends Component {
  // products;
  // this.props.order.order.products
  render() {
    const cartTotalDiscountPrice =
      this.props.products.length > 0
        ? parseFloat(
            this.props.products
              .map((product) => {
                return product.categories
                  ? parseFloat(
                      calculatePrice(
                        product,
                        activeDiscount(product.categories)
                      )
                    )
                  : 0;
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    // Sipariş detaylarında her ürünün price alanı zaten toplam fiyat (miktar x birim fiyat)
    const cartTotalPrice =
      this.props.order[this.props.customer ? "order" : "orderEnquiry"].products
        .length > 0
        ? parseFloat(
            this.props.order[
              this.props.customer ? "order" : "orderEnquiry"
            ].products
              .map(({ price }) => price)
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    return (
      <table
        className={"table table-bordered table-hover order-detail"}
        style={{ marginTop: 20 }}
      >
        <thead>
          <tr>
            <th>Ürün Resmi</th>
            <th>Ürün Adı</th>
            <th>Miktarı</th>
            <th>Birim Fiyatı</th>
            <th>Toplam</th>
          </tr>
        </thead>

        <tbody>
          {this.props.order[
            this.props.customer ? "order" : "orderEnquiry"
          ].products.map(({ product, quantity, price }, i) =>
            !product ? (
              <tr>
                <td className={"text-center"}>
                  <Link to={`#`}>
                    <img
                      src={"/images/no-product.png"}
                      style={{ width: 120 }}
                    />
                  </Link>
                </td>
                <td>
                  <Link to={`#`}>Ürün kaldırılmış olabilir.</Link>
                </td>
                <td>{quantity}</td>
                <td>₺0</td>
                <td>₺{price}</td>
              </tr>
            ) : (
              <tr key={i}>
                <td className={"text-center"}>
                  <Link
                    to={{
                      pathname: `/urun/${product.slug}`,
                      // state: { product: this.props.product },
                    }}
                  >
                    <img
                      style={{ width: 120 }}
                      alt={product.name}
                      src={PUBLIC_URL(product.image)}
                    />
                  </Link>
                </td>
                <td>
                  <Link
                    to={{
                      pathname: `/urun/${product.slug}`,
                      // state: { product: this.props.product },
                    }}
                  >
                    {product.name}
                  </Link>
                </td>
                <td>{quantity}</td>
                <td>
                  <span
                    style={{
                      color: activeDiscount(product.categories)
                        ? "#ccc"
                        : "#000",
                      textDecoration: activeDiscount(product.categories)
                        ? "line-through"
                        : "none",
                    }}
                  >
                    ₺
                    {product.sale_price
                      ? parseFloat(product.sale_price).toFixed(2)
                      : parseFloat(product.price).toFixed(2)}
                  </span>
                  {activeDiscount(product.categories) ? (
                    <React.Fragment>
                      <br />₺
                      {activeDiscount(product.categories).type === "percent"
                        ? product.sale_price
                          ? parseFloat(
                              product.sale_price *
                                (1 -
                                  activeDiscount(product.categories).discount /
                                    100)
                            ).toFixed(2)
                          : parseFloat(
                              product.price *
                                (1 -
                                  activeDiscount(product.categories).discount /
                                    100)
                            ).toFixed(2)
                        : product.sale_price
                        ? parseFloat(
                            product.sale_price -
                              activeDiscount(product.categories).discount
                          ).toFixed(2)
                        : parseFloat(
                            product.price -
                              activeDiscount(product.categories).discount
                          ).toFixed(2)}
                    </React.Fragment>
                  ) : null}
                </td>
                <td>₺{price}</td>
              </tr>
            )
          )}
        </tbody>
        <tfoot>
          <tr>
            <td className={"text-right"} colSpan={4}>
              <strong>Ara Toplam:</strong>
            </td>
            <td className={"text-center"}>
              ₺{parseFloat(cartTotalPrice).toFixed(2)}
            </td>
          </tr>

          {this.props.order[this.props.customer ? "order" : "orderEnquiry"]
            .shipping_cost > 0 ? (
            <tr>
              <td className={"text-right"} colSpan={4}>
                <strong>Kargo:</strong>
              </td>
              <td className={"text-center"}>
                ₺
                {parseFloat(
                  this.props.order[
                    this.props.customer ? "order" : "orderEnquiry"
                  ].shipping_cost
                ).toFixed(2)}
              </td>
            </tr>
          ) : null}

          {this.props.order[this.props.customer ? "order" : "orderEnquiry"]
            .shipping_cost === 0 &&
          this.props.setting &&
          this.props.setting.setting ? (
            <tr>
              <td className={"text-right"} colSpan={4}>
                <strong>
                  {parseFloat(this.props.setting.setting.free_shipping).toFixed(
                    2
                  )}{" "}
                  TL ve Üzeri Ücretsiz Kargo
                </strong>
              </td>
              <td className={"text-center"} style={{ color: "rgb(205 26 52)" }}>
                -₺
                {parseFloat(this.props.setting.setting.shipping_cost).toFixed(
                  2
                )}
              </td>
            </tr>
          ) : null}

          {this.props.order[this.props.customer ? "order" : "orderEnquiry"]
            .discount &&
          this.props.order[this.props.customer ? "order" : "orderEnquiry"]
            .discount > 0 ? (
            <tr>
              <td className={"text-right"} colSpan={4}>
                <strong>Sepette İndirim</strong>
              </td>
              <td className={"text-center"} style={{ color: "rgb(205 26 52)" }}>
                -₺
                {parseFloat(
                  this.props.order[
                    this.props.customer ? "order" : "orderEnquiry"
                  ].discount
                ).toFixed(2)}
              </td>
            </tr>
          ) : null}

          {(() => {
            const orderData =
              this.props.order[this.props.customer ? "order" : "orderEnquiry"];
            const customerDiscount = orderData.customer_discount;

            return customerDiscount && parseFloat(customerDiscount) > 0 ? (
              <tr>
                <td className={"text-right"} colSpan={4}>
                  <strong>Premium Müşteri İndirimi</strong>
                </td>
                <td
                  className={"text-center"}
                  style={{ color: "rgb(205 26 52)" }}
                >
                  -₺{parseFloat(customerDiscount).toFixed(2)}
                </td>
              </tr>
            ) : null;
          })()}

          <tr>
            <td className={"text-right"} colSpan={4}>
              <strong>Toplam:</strong>
            </td>
            <td className={"text-center"}>
              ₺
              {parseFloat(
                this.props.order[this.props.customer ? "order" : "orderEnquiry"]
                  .total_price
              ).toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
}

const mapStateToProps = ({ setting, cart }) => {
  return { setting, cart };
};

const mapDispatchToProps = {
  recentlyAddedProducts,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderDetailProducts);



// WEBPACK FOOTER //
// ./src/components/OrderDetailProducts.js